<div id="todo" class="page-layout carded left-sidebar inner-scroll">



    <!-- CENTER -->
    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <table class="table p-24">
                <tbody>
                <tr>
                    <td><b>{{'Product'| translate}}</b></td>
                    <td>{{stocks[0].product.name}}</td>
                </tr>
                <tr>
                    <td><b>{{'Current quantity'| translate}}</b></td>
                    <td>{{stocks[0].quantity}}</td>
                </tr>
                <tr>
                    <td><b>{{'Last change'| translate}}</b></td>
                    <td>{{stocks[0].updatedAt | date:'dd.MM.yyyy H:mm:ss':'UTC'}}</td>
                </tr>
                </tbody>
            </table>

            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Quantity' | translate}}" prop="name">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.quantity}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Type' | translate}}" prop="name">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.type}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Created by' | translate}}" prop="createdBy">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.createdBy" [ngStyle]="{color: row.color}">
                                    {{row.createdBy.firstName}} {{row.createdBy.lastName}} ({{row.createdBy.username}})
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Created at' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span [ngStyle]="{color: row.color}">
                                    {{row.createdAt | date:'dd.MM.yyyy H:mm:ss':'UTC'}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
<!--                                <a *appIsGranted="['Voucher templates', 'UPDATE']" routerLink="/settings/voucher-template-groups/edit/{{row.id}}">{{'Edit'|translate}}</a>-->

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
